import { ReactComponent as DownArrow } from "../../../../assets/icons/downArrow.svg";

import Button from "../../../../../common/components/button";
import TableName from "../../../../components/common/tableName";
import Input from "../../../../components/common/input";
import { GetCustomerResponse } from "../../../../../common/hooks/console/management/customer/useGetCustomerInfo";
// import SearchAddress from "../../../../components/common/searchAddress";
import React, { useEffect, useState } from "react";
import useToastStore from "../../../../store/useToastStore";
import { usePutCustomerInfo } from "../../../../../common/hooks/console/management/customer/usePutCustomerInfo";
import { useSystemPopStore } from "../../../../store/useSystemPopStore";
import { useDeleteCustomer } from "../../../../../common/hooks/console/management/customer/useDeleteCustomer";
import SystemPop from "../../../../components/common/systemPop";
import { usePostCustomerMemo } from "../../../../../common/hooks/console/management/customer/usePostCustomerMemo";
import { usePutCustomerMemo } from "../../../../../common/hooks/console/management/customer/usePutCustomerMemo";
import { useGetCustomerMemo } from "../../../../../common/hooks/console/management/customer/useGetCustomerMemo";
import { useDeleteCustomerMemo } from "../../../../../common/hooks/console/management/customer/useDeleteCustomerMemo";
import { useAuthStore } from "../../../../store/useAuthStore";
import NewOrderSearchAddress from "console/components/common/newOrderSearchAddress";

interface OtherCustomerProps {
    data?: GetCustomerResponse;
    id: number;
    special?: boolean;
    onComplete: (id: number) => void;
}

const OtherCustomer = ({ data, id, special, onComplete }: OtherCustomerProps) => {
    const { addToast } = useToastStore();
    const { showPop } = useSystemPopStore();
    const level = useAuthStore(state => state.m_level);
    const name = useAuthStore(state => state.m_name);

    const initialState = {
        customerName: data?.customer_name || "",
        zoneCode: data?.customer_post || "",
        address: data?.customer_address || "",
        detailAddress: data?.customer_address_detail || "",
        managerName: data?.customer_manager[0]?.manager_name || "",
        managerMobile: data?.customer_manager[0]?.manager_mobile || "",
        managerEmail: data?.customer_manager[0]?.manager_email || "",
    };

    const [customerName, setCustomerName] = useState<string>(data?.customer_name ?? "");
    const [zoneCode, setZoneCode] = useState<string>(data?.customer_post ?? "");
    const [address, setAddress] = useState<string>(data?.customer_address ?? "");
    const [detailAddress, setDetailAddress] = useState<string>(data?.customer_address_detail ?? "");
    const [managerName, setManagerName] = useState<string>(data?.customer_manager[0]?.manager_name ?? "");
    const [managerMobile, setManagerMobile] = useState<string>(data?.customer_manager[0]?.manager_mobile ?? "");
    const [managerEmail, setManagerEmail] = useState<string>(data?.customer_manager[0]?.manager_email ?? "");
    const [customerMemo, setCustomerMemo] = useState<string>("");
    const [editIndex, setEditIndex] = useState<number | null>(null);
    const [editMemo, setEditMemo] = useState("");
    const [collapsedSections, setCollapsedSections] = useState<{ [key: string]: boolean }>({
        customer: false,
        memo: false,
    });

    const [customerNameError, setCustomerNameError] = useState(false);
    const [addressError, setAddressError] = useState(false);
    const [managerError, setManagerError] = useState(false);
    const [managerEmailError, setManagerEmailError] = useState(false);
    const [managerMobileError, setManagerMobileError] = useState(false);

    const toggleSection = (section: string) => {
        setCollapsedSections(prev => ({
            ...prev,
            [section]: !prev[section],
        }));
    };

    const deleteCustomerMutation = useDeleteCustomer();
    const handleDelete = () => {
        showPop({
            title: "해당 내역을 삭제하시겠습니까",
            rightButton: "확인",
            type: "negative",
            onRightClick: () => {
                addToast({
                    type: "delete",
                    onConfirmDelete: () =>
                        deleteCustomerMutation.mutate(
                            { id },
                            {
                                onSuccess: () => {
                                    onComplete(id);
                                },
                            },
                        ),
                });
            },
        });
    };

    const putCustomerMutation = usePutCustomerInfo(() => {
        addToast({
            type: "success",
            message: "고객정보가 변경되었습니다.",
        });
    });
    const handleSave = () => {
        let hasError = false;

        if ((customerName?.trim() ?? "") === "") {
            setCustomerNameError(true);
            hasError = true;
        }
        if ((zoneCode?.trim() ?? "") === "" || (address?.trim() ?? "") === "") {
            setAddressError(true);
            hasError = true;
        }
        if ((managerName?.trim() ?? "") === "") {
            setManagerError(true);
            hasError = true;
        }
        if ((managerEmail?.trim() ?? "") === "") {
            setManagerEmailError(true);
            hasError = true;
        }
        if ((managerMobile?.trim() ?? "") === "") {
            setManagerMobileError(true);
            hasError = true;
        }

        if (hasError) return;

        const payload = {
            id: id,
            data: {
                customer_name: customerName,
                customer_post: zoneCode,
                customer_address: address,
                customer_address_detail: detailAddress,
                manager_name: managerName,
                manager_mobile: managerMobile,
                manager_email: managerEmail,
            },
        };

        putCustomerMutation.mutate(payload);
    };

    const handleCancel = () => {
        setCustomerName(initialState.customerName);
        setZoneCode(initialState.zoneCode);
        setAddress(initialState.address);
        setDetailAddress(initialState.detailAddress);
        setManagerName(initialState.managerName);
        setManagerMobile(initialState.managerMobile);
        setManagerEmail(initialState.managerEmail);

        setCustomerNameError(false);
        setAddressError(false);
        setManagerError(false);
        setManagerEmailError(false);
        setManagerMobileError(false);
    };

    //연락처 형식 관리
    const formatPhoneNumber = (value: string) => {
        const cleaned = value.replace(/\D+/g, "");
        if (cleaned.length <= 3) return cleaned;
        if (cleaned.length <= 7) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
        return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7, 11)}`;
    };

    //메모 관리 (등록, 수정, 삭제)
    const { mutate: memoMutate } = usePostCustomerMemo(() => setCustomerMemo(""), id);
    const { mutate: memoModifyMutate } = usePutCustomerMemo(() => setEditIndex(null));
    const { data: memoData } = useGetCustomerMemo(id);
    const deleteCustomerMemoMutation = useDeleteCustomerMemo();
    const handleMemoSave = () => {
        customerMemo &&
            memoMutate({
                customer_memo: customerMemo,
            });
    };
    const handleMemoModify = (customerId: number, memoId: number) => {
        editMemo &&
            memoModifyMutate({
                customerId,
                memoId,
                customerMemoData: { customer_memo: editMemo },
            });
    };
    const handleEdit = (memoId: number, memo: string) => {
        setEditIndex(memoId);
        setEditMemo(memo);
    };
    const handleMemoCancel = () => {
        setEditIndex(null);
        setEditMemo("");
    };
    const handleMemoDelete = (customerId: number, memoId: number) => {
        deleteCustomerMemoMutation.mutate({
            customerId,
            memoId,
        });
    };

    //주소 관리
    const handleAddressChange = (newZoneCode: string, newAddress: string, newDetailAddress: string) => {
        setZoneCode(newZoneCode);
        setAddress(newAddress);
        setDetailAddress(newDetailAddress);
        setAddressError(false);
    };

    useEffect(() => {
        if (data) {
            setCustomerName(data.customer_name);
            setZoneCode(data.customer_post);
            setAddress(data.customer_address);
            setDetailAddress(data.customer_address_detail);
            setManagerName(data.customer_manager[0]?.manager_name);
            setManagerMobile(data.customer_manager[0]?.manager_mobile);
            setManagerEmail(data.customer_manager[0]?.manager_email);
        }
    }, [data]);

    return (
        <div className="bg-gray6 p-4 h-full flex flex-col gap-2  overflow-y-auto">
            {/* Header */}
            <div className="flex items-center justify-between gap-4 bg-white px-4 py-2 rounded-xl">
                <p className="font-bold text-xl truncate">{data?.customer_name}</p>
                {level === 7 || level === 8 || special || (
                    <Button onClick={handleDelete} status="error" size="S" className="px-2 whitespace-nowrap">
                        고객정보 삭제
                    </Button>
                )}
            </div>
            <div className="flex flex-col gap-2">
                {/* 고객정보 */}
                <div className="bg-white rounded-xl px-3 py-5 flex flex-col gap-5">
                    <div className="flex items-center justify-between">
                        <p className="text-xl font-bold">고객정보 - 타지점</p>
                        <p className="text-sm text-gray2">{data?.reg_date} 등록</p>
                    </div>
                    <div className="flex flex-col gap-3">
                        <div className="flex items-center justify-between">
                            <p className="font-bold text-gray2">기본정보</p>
                            <DownArrow
                                onClick={() => toggleSection("customer")}
                                className={`transform transition-transform cursor-pointer ${collapsedSections.customer ? "rotate-180" : ""}`}
                            />
                        </div>
                        {!collapsedSections.customer && (
                            <>
                                <div className="border-t-2 border-gray2">
                                    <div className="border-b border-gray4 flex items-center">
                                        <TableName required className="h-12">
                                            거래처명
                                        </TableName>
                                        <Input
                                            placeholder="거래처명 입력"
                                            value={customerName ?? ""}
                                            onChange={e => {
                                                setCustomerName(e.target.value);
                                                setCustomerNameError(false);
                                            }}
                                            status={customerNameError ? "error" : level === 7 ? "view" : undefined}
                                            className="p-2 w-full"
                                        />
                                    </div>
                                    <div className="border-b border-gray4 flex items-stretch">
                                        <TableName required>주소</TableName>
                                        <NewOrderSearchAddress
                                            post={zoneCode}
                                            customerAddress={address}
                                            customerAddressDetail={detailAddress}
                                            onAddressChange={handleAddressChange}
                                            status={addressError ? "error" : level === 7 ? "view" : undefined}
                                        />
                                    </div>
                                    <div className="border-b border-gray4 flex items-stretch">
                                        <TableName required>담당자</TableName>
                                        <div className="flex flex-col gap-1 p-2 w-full">
                                            <Input
                                                placeholder="담당자 이름"
                                                value={managerName ?? ""}
                                                onChange={e => {
                                                    setManagerName(e.target.value);
                                                    setManagerError(false);
                                                }}
                                                status={managerError ? "error" : level === 7 ? "view" : undefined}
                                            />
                                            <div className="flex gap-1">
                                                <Input
                                                    className=" w-full"
                                                    placeholder="담당자 연락처"
                                                    value={managerMobile ?? ""}
                                                    onChange={e => setManagerMobile(formatPhoneNumber(e.target.value))}
                                                    status={managerMobileError ? "error" : level === 7 ? "view" : undefined}
                                                />
                                                <Input
                                                    className=" w-full"
                                                    placeholder="담당자 이메일"
                                                    value={managerEmail ?? ""}
                                                    onChange={e => {
                                                        setManagerEmail(e.target.value);
                                                        setManagerEmailError(false);
                                                    }}
                                                    status={managerEmailError ? "error" : level === 7 ? "view" : undefined}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {level !== 7 && (
                                    <div className="flex w-full gap-2">
                                        <Button className="w-full" size="L" onClick={handleCancel}>
                                            취소
                                        </Button>
                                        <Button onClick={handleSave} status="regist" className="w-full" size="L">
                                            저장
                                        </Button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    <div className="flex flex-col gap-3 ">
                        <div className="flex items-center justify-between">
                            <p className="font-bold text-gray2">메모</p>
                            <DownArrow
                                onClick={() => toggleSection("memo")}
                                className={`transform transition-transform cursor-pointer ${collapsedSections.memo ? "rotate-180" : ""}`}
                            />
                        </div>
                        {!collapsedSections.memo && (
                            <>
                                {level !== 7 && (
                                    <div className="flex items-center justify-between bg-gray6 p-3 rounded-xl gap-4">
                                        <textarea
                                            className="w-full text-sm py-1.5 rounded-lg h-8 outline-0 border px-3 flex resize-none overflow-hidden"
                                            placeholder="메모 100자"
                                            value={customerMemo}
                                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                                const inputValue = e.target.value;
                                                if (inputValue.length <= 100) {
                                                    setCustomerMemo(inputValue);
                                                }
                                            }}
                                            onInput={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                                const target = e.target;
                                                target.style.height = "32px";
                                                target.style.height = `${Math.max(target.scrollHeight, 32)}px`;
                                            }}
                                        />
                                        <Button
                                            onClick={handleMemoSave}
                                            className="px-2.5 whitespace-nowrap h-full items-center flex"
                                            size="S"
                                            status="regist"
                                        >
                                            메모등록
                                        </Button>
                                    </div>
                                )}

                                {memoData &&
                                    memoData.data.map((memo, index) => (
                                        <div key={index} className="flex border-b gap-4 border-gray4 p-3 w-full">
                                            <div className="flex flex-col gap-2 w-full">
                                                {editIndex === memo.customer_memo_idx || (
                                                    <div className="flex gap-2 items-center">
                                                        <p className="text-sm text-gray2">{memo.member_name}</p>
                                                        <p className="text-xs text-gray3">{memo.reg_date}</p>
                                                    </div>
                                                )}

                                                {editIndex === memo.customer_memo_idx ? (
                                                    <textarea
                                                        className="w-full text-sm py-1.5 rounded-lg h-8 outline-0 border px-3 flex resize-none overflow-hidden"
                                                        placeholder="메모 100자"
                                                        value={editMemo}
                                                        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                                            const inputValue = e.target.value;
                                                            if (inputValue.length <= 100) {
                                                                setEditMemo(inputValue);
                                                            }
                                                        }}
                                                        onInput={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                                            const target = e.target;
                                                            target.style.height = "32px";
                                                            target.style.height = `${Math.max(target.scrollHeight, 32)}px`;
                                                        }}
                                                    />
                                                ) : (
                                                    <p className="text-sm">{memo.customer_memo}</p>
                                                )}
                                            </div>
                                            {level !== 7 &&
                                                (level !== 8 || memo.member_name === name) &&
                                                (editIndex === memo.customer_memo_idx ? (
                                                    <div className="flex items-center gap-1">
                                                        <Button size="S" className="px-2 whitespace-nowrap" onClick={handleMemoCancel}>
                                                            취소
                                                        </Button>
                                                        <Button
                                                            status="regist"
                                                            size="S"
                                                            className="px-2 whitespace-nowrap"
                                                            onClick={() => handleMemoModify(id, memo.customer_memo_idx)}
                                                        >
                                                            수정
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    <div className="flex items-center gap-1">
                                                        <Button
                                                            size="S"
                                                            className="px-2 whitespace-nowrap"
                                                            onClick={() => handleEdit(memo.customer_memo_idx, memo.customer_memo)}
                                                        >
                                                            수정
                                                        </Button>
                                                        <Button
                                                            size="S"
                                                            className="px-2 whitespace-nowrap"
                                                            onClick={() => handleMemoDelete(id, memo.customer_memo_idx)}
                                                        >
                                                            삭제
                                                        </Button>
                                                    </div>
                                                ))}
                                        </div>
                                    ))}
                            </>
                        )}
                    </div>
                </div>
            </div>
            <SystemPop />
        </div>
    );
};

export default OtherCustomer;
